export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13884.5671b15e.jpg";